//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import H1 from "./h1";
import H2 from "./h2";
import H3 from "./h3";
import H4 from "./h4";
import H5 from "./h5";
import H6 from "./h6";
import Label from "./label";
import P from "./p";
import Markdown from "./markdown";
import Html from "./html";
import Chip from "./chip";
import Datetime from "./datetime";
import ProgressBar from "./progressbar";
import ProgressCircle from "./progressCircle.vue";
import Image from "./image";
import Avatar from "./avatar";
import Icon from "./icon";
import Button from "./button";
import Fab from "./fab";
import Switch from "./switch";
import Hr from "./hr";
import Spacer from "./spacer";
import Map from "./map";
import TabBar from "./tabBar";
import Calendar from "./calendar";
import HiddenField from "./fields/hidden";
import TextField from "./fields/text";
import SubmitField from "./fields/submit";
import TextAreaField from "./fields/textarea";
import RichTextField from "./fields/richText";
import NewRichTextField from "./fields/newRichText";
import FileField from "./fields/file";
import AutocompleteField from "./fields/autocomplete";
import SelectField from "./fields/select";
import TimeZoneField from "./fields/timeZone";
import DynamicSelectField from "./fields/dynamicSelect";
import CountryField from "./fields/country/field";
import RadioGroupField from "./fields/radioGroup";
import RadioField from "./fields/radio";
import CheckGroupField from "./fields/checkGroup";
import CheckField from "./fields/check";
import DateField from "./fields/date";
import DateTimeField from "./fields/datetime";
import LocationField from "./fields/location";
import GooglePlaceField from "./fields/googlePlace";
import DynamicGroupField from "./fields/dynamicGroup";
import StripeTokenField from "./fields/stripeToken";
import StripeExternalAccount from "./fields/stripeExternalAccount";
import CreditCardField from "./fields/creditCard";
import RatingField from "./fields/rating";
import PhoneField from "./fields/phone/field";
import TimerField from "./fields/timer";
import ScrollPanel from "./panels/scroll";
import VerticalPanel from "./panels/vertical";
import HorizontalPanel from "./panels/horizontal";
import FlowPanel from "./panels/flow";
import SplitPanel from "./panels/split";
import FormPanel from "./panels/form";
import ListPanel from "./panels/list";
import CarouselPanel from "./panels/carousel";
import TablePanel from "./panels/table";
import CustomPanel from "./panels/custom";
import ColumnPanel from "./panels/column";
import ResponsivePanel from "./panels/responsive";
import UlPanel from "./panels/ul";
import WebPanel from "./panels/web";
import GridPanel from "./panels/grid";
import TimelinePanel from "./panels/timeline";
import MultimediaVideo from "./multimedia/video";
import AlertBanner from "./banners/alert";
import SelectBanner from "./banners/select";
import LineChart from "./charts/line";
import ColumnChart from "./charts/column";
import PieChart from "./charts/pie";
import ShareButton from "./shareButton";
export default {
  components: {
    "views-h1": H1,
    "views-h2": H2,
    "views-h3": H3,
    "views-h4": H4,
    "views-h5": H5,
    "views-h6": H6,
    "views-label": Label,
    "views-p": P,
    "views-markdown": Markdown,
    "views-html": Html,
    "views-chip": Chip,
    "views-datetime": Datetime,
    "views-progressBar": ProgressBar,
    "views-progressCircle": ProgressCircle,
    "views-image": Image,
    "views-avatar": Avatar,
    "views-icon": Icon,
    "views-button": Button,
    "views-fab": Fab,
    "views-switch": Switch,
    "views-hr": Hr,
    "views-spacer": Spacer,
    "views-map": Map,
    "views-tabBar": TabBar,
    "views-calendar": Calendar,
    "views-shareButton": ShareButton,
    "fields-hidden": HiddenField,
    "fields-text": TextField,
    "fields-submit": SubmitField,
    "fields-textarea": TextAreaField,
    "fields-richText": RichTextField,
    "fields-newRichText": NewRichTextField,
    "fields-file": FileField,
    "fields-autocomplete": AutocompleteField,
    "fields-select": SelectField,
    "fields-timeZone": TimeZoneField,
    "fields-dynamicSelect": DynamicSelectField,
    "fields-country": CountryField,
    "fields-radioGroup": RadioGroupField,
    "fields-radio": RadioField,
    "fields-checkGroup": CheckGroupField,
    "fields-check": CheckField,
    "fields-date": DateField,
    "fields-datetime": DateTimeField,
    "fields-location": LocationField,
    "fields-googlePlace": GooglePlaceField,
    "fields-dynamicGroup": DynamicGroupField,
    "fields-stripeToken": StripeTokenField,
    "fields-stripeExternalAccount": StripeExternalAccount,
    "fields-creditCard": CreditCardField,
    "fields-rating": RatingField,
    "fields-phone": PhoneField,
    "fields-timer": TimerField,
    "panels-scroll": ScrollPanel,
    "panels-vertical": VerticalPanel,
    "panels-horizontal": HorizontalPanel,
    "panels-flow": FlowPanel,
    "panels-split": SplitPanel,
    "panels-form": FormPanel,
    "panels-list": ListPanel,
    "panels-carousel": CarouselPanel,
    "panels-table": TablePanel,
    "panels-custom": CustomPanel,
    "panels-responsive": ResponsivePanel,
    "panels-column": ColumnPanel,
    "panels-ul": UlPanel,
    "panels-web": WebPanel,
    "panels-grid": GridPanel,
    "panels-timeline": TimelinePanel,
    "multimedia-video": MultimediaVideo,
    "banners-alert": AlertBanner,
    "banners-select": SelectBanner,
    "charts-line": LineChart,
    "charts-column": ColumnChart,
    "charts-pie": PieChart
  },
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      name: null
    };
  },
  beforeUpdate: function beforeUpdate() {// NOTE: Not sure what this is for
    // Make sure vuejs will not attempt to render old data.
    // if (this._mountedUrl !== window.location.href) {
    //   this.name = null;
    // }
  },
  methods: {
    $ready: function $ready() {
      var name = Utils.app.componentName(this.spec.view);
      var strict = true;

      if (strict) {
        this.name = name;
      } else {
        if (this.$options.components[name]) {
          this.name = name;
        }
      }
    }
  }
};